import React, { useState } from "react";
import Select from 'react-select';
import alcohol_styles from './Alcohol.module.css';
import styled from 'styled-components';
import beerImage from "../resources/Beer.png";
import blackBeerImage from "../resources/Black beer.png";
import wineImage from "../resources/Coffee.png";
import liquorImage from "../resources/Liquor.png";
import { DropdownIndicator } from "./CandidateInfo";
import QuestionBox from "../components/QuestionBox";
import { QuestionNumber as BaseQuestionNumber } from "./VapeView";
import SliderComp from "./SliderComp";
import Cheers from '../resources/cheers.svg';
import Clock from '../resources/clock.svg';
import StandardAlcoholImg from '../resources/NIH_standard_drink_comparison.jpg';

const FlexBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;
  padding-top: 20px;
  @media (max-width: 576px) { flex-direction: column; }
`;

export const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '5px',
    borderColor: '#93B3FC',
    minHeight: '20px',
    height: '30px',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
    width: '200px'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#93B3FC',
    height: '5px',
    width: '5px',
  }),
};

const Alcohol = (props) => {
  const questions = [
    "How often do you have a drink containing alcohol?",
    "How often do you have five or more drinks on one occasion?",
    "How often have you found that you were not able to stop drinking once you have started?",
    "How often have you failed to do what was normally expected from you because of drinking?",
    "How often have you needed a drink in the morning to get yourself going after a heavy drinking session?",
    "How often have you had a feeling of guilt or remorse after drinking?",
    "How often have you been unable to remember what happened the night before because you had been drinking?",
    "Have you or someone else been injured as a result of your drinking?",
    "Has a relative, friend, doctor, or other health worker been concerned about your drinking or suggested that you should cut down?"
  ];

  const [answers, setAnswers] = useState(Array(11).fill(999));
// helper (once, above useEffect)
const drinksToAuditQ2 = (d = 0) => {
  const n = Number(d) || 0;
  if (n <= 2) return 0;
  if (n <= 4) return 1;
  if (n <= 6) return 2;
  if (n <= 9) return 3;
  return 4; // 10+
};

React.useEffect(() => {
  const unanswered = answers.some(a => a === 999);
  if (!unanswered) {
    const data = {
      // AUDIT Q1 (frequency)
      AUDIT1: Number(answers[0]),

      // Q3..Q10 (your existing names)
      AUDIT2:  Number(answers[1]),  // Q3: 5+ drinks
      THRIVE2: Number(answers[2]),  // Q4
      THRIVE3: Number(answers[3]),  // Q5
      THRIVE4: Number(answers[4]),  // Q6
      THRIVE5: Number(answers[5]),  // Q7
      THRIVE6: Number(answers[6]),  // Q8
      THRIVE7: Number(answers[7]),  // Q9
      THRIVE8: Number(answers[8]),  // Q10
    
      // sliders / raw
      THRIVE1:     Number(answers[9]),   // typical drinks for charts/BAC
      DRINKSBYHOUR: Number(answers[10]),

      // derived (optional but handy)
      AUDIT_Q2_SCORE: drinksToAuditQ2(Number(answers[9])),
    };
    console.log("📝 Alcohol.js → Final answers payload being sent to backend:", data);

    props.setAlcoholAnswersData(data);
    props.setNextButton(true);
    props.onAllAnswered(false);
  } else {
    props.setNextButton(false);
  }
}, [answers]);
// AUDIT Q1 uses normal scoring (0..4). Keep it as a number.
const normalizeForAuditQ1 = (v) => Number(v);

  const handleAnswerChange = (index, value) => {
    const newAnswers = [...answers];
    newAnswers[index] = (index === 0) ? normalizeForAuditQ1(value) : value;
    setAnswers(newAnswers);
  };

  // Q1 (AUDIT) options – value 2 now explicitly reads as “Once a week …”
  const options1 = [
    { value: '0', label: 'Never' },
    { value: '1', label: 'Monthly or less' },
    { value: '2', label: '2–4 times/month' }, // scores 2
    { value: '3', label: '2–3 times a week' },
    { value: '4', label: '4 or more times a week' },
    { value: '98', label: 'No Response' }
  ];

  // Other AUDIT frequency questions keep standard scoring (Weekly = 3)
  const options3 = [
    { value: '0', label: 'Never' },
    { value: '1', label: 'Less than monthly' },
    { value: '2', label: 'Monthly' },
    { value: '3', label: 'Weekly' },
    { value: '4', label: 'Daily or almost daily' },
    { value: '98', label: 'No Response' }
  ];

  const options4 = [
    { value: '0', label: 'No' },
    { value: '2', label: 'Yes, but not in the past year' },
    { value: '4', label: 'Yes, during the past year' },
   
    { value: '98', label: 'No Response' }
  ];

  const quesToOptions = {
    0: options1, // Q1: uses the fixed mapping above
    1: options3,
    2: options3,
    3: options3,
    4: options3,
    5: options3,
    6: options3,
    7: options4,
    8: options4,
  };

  return (
    <>
      <div className={alcohol_styles.container}>
        <h2 className={alcohol_styles.mainTitle}>Let's think about your Alcohol Use for the past year:</h2>

        <QuestionSection>
          <QuestionBox width={'auto'} question={"How many standard drinks containing alcohol do you have on a typical day when you are drinking?"} index={1} />
          <div style={{width: '100%', marginTop: '10px'}}>
            <StandardDrinkImg src={StandardAlcoholImg} alt="Standard Alcohol" />
          </div>
          <SliderComp handleAnswerChange={(value)=>handleAnswerChange(9, value)} index={9} answer={answers[9]} icon={Cheers} showPlus={true} />
        </QuestionSection>

        <QuestionSection>
          <QuestionBox width={'auto'} question={"Over how many hours do you drink this standard amount of drinks on a typical day?"} index={2} />
          <SliderComp handleAnswerChange={(value)=>handleAnswerChange(10, value)} index={10} answer={answers[10]} maxValue={24} icon={Clock} />
        </QuestionSection>

        <div style={{display:'flex', flexDirection:'row', justifyContent:'end', marginRight:'-10%'}}>
          <img className={alcohol_styles.image} style={{width:'60px', height:'80px', marginRight:'-10px'}} src={beerImage} alt="beer" />
          <img className={alcohol_styles.image} style={{width:'30px', height:'30px', marginRight:'10px', marginTop:'50px'}} src={blackBeerImage} alt="beer" />
          <img className={alcohol_styles.image} style={{width:'50px', height:'80px', marginLeft:'-30px'}} src={wineImage} alt="beer" />
          <img className={alcohol_styles.image} style={{width:'80px', height:'50px', marginLeft:'-40px', marginTop:'25px'}} src={liquorImage} alt="beer" />
        </div>

        {questions.map((question, index) => (
          <FlexBox key={index}>
            <QuestionBox
              color={(props.showUnanswered && answers[index] === 999) ? 'red' : 'black'}
              width={'70%'}
              question={question}
              index={index+3}
            />
            <div className={alcohol_styles.answer}>
              <Select
                options={quesToOptions[index]}
                components={{ DropdownIndicator }}
                styles={customStyles}
                placeholder="Select an option"
                onChange={(op) => handleAnswerChange(index, op.value)}
                isSearchable={false}   // 👈 add this\
              />
            </div>
          </FlexBox>
        ))}
      </div>
    </>
  );
};

const QuestionNumber = styled(BaseQuestionNumber)`
  top: 23px;
  @media only screen and (max-width: 700px) { top: 24px; }
`;

const QuestionSection = styled.section`
  position: relative;
  margin: 0 0 20px 0;
  padding-top: 20px;
  @media only screen and (max-width: 700px) {
    margin-top: 10px;
    margin-bottom: 0px;
  }
`;

const StandardDrinkImg = styled.img`
  width: 50%;
  height: 50%;
  display: block;
  margin: 0 auto;
  @media only screen and (max-width: 780px) { width: 70%; height: 70%; }
  @media only screen and (max-width: 576px) { width: 100%; height: 100%; }
`;

export default Alcohol;
